const state = {
  roi_area: {
    boxHeight: 364,
    boxWidth: 1024,
    blockH: 100,
    blockW: 100,
    rowNum: 5,
    colNum: 19,
    limit: 95
  }
};

const getters = {
  roi_area: state => state.roi_area
};

const mutations = {
  SET_ROI_AREA(state, value) {
    state.roi_area = value;
    localStorage.setItem('roi_area', JSON.stringify(value));
  }
};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
